<template>
  <div>
      <a-card title="菜单管理">
      <a-button slot="extra" type="primary" @click="handleNewMenu">新建菜单</a-button>

          <a-tree
              :tree-data="treeData"
              :show-line="showLine"
              :show-icon="showIcon"
              :auto-expand-parent="autoExpandParent"
              @select="onSelect"
              @check="onCheck"
          >
           <template slot="custom" slot-scope="item" >
            <span>{{ item.title }}</span>
              <a-button
                type="link"
                class="but_type"
                style="right:120px;"
                @click="()=> append(item)"
              >新建下级</a-button>
              <a-button
                type="link"
                class="but_type"
                style="right:80px;"
                @click="()=> edit(item)"
              >编辑</a-button>

              <a-popconfirm   @confirm="() => remove(item)">
                <template slot="title">
                    <p>{{ '确认将【' + item.name+ '】删除？' }}</p>
                </template>
              <a-button  type="link" class="but_type">删除</a-button>
            </a-popconfirm>


              <div class="underline"></div>
          </template>

          </a-tree>
          <menuItem  ref="addeditmenu"  @onModalHide="handleModalHide"></menuItem>
      </a-card>
  </div>
</template>
<script>
import menuItem from './menuitem'
export default {
    data() {
        return {
            showLine: true,
            showIcon: false,
            treeData:[],
            autoExpandParent:false,
        };
    },
    methods: {
        handleNewMenu(){
            let empty_menu = {
                title:'新建一级菜单',
                pid: '-1',
                url:'',
                level: '1',
                name:'',
                ordernum:'',
                id:'',
                subname:'',
                icon:''
            }
            this.$refs.addeditmenu.onModalInit(empty_menu);
        },
        handleModalHide(){
            
            this.getAllMenu()
        },
        onSelect(){},
        onCheck(){},

        //新建下级
        append(item){
            console.log(item)
            let empty_menu = {
                title:'新建【' + item.name + '】的下级',
                pid:item.id,
                url:'',
                level: parseInt(item.level) + 1,
                name:'',
                ordernum:'',
                id:'',
                subname:'',
                icon:''
            }
            this.$refs.addeditmenu.onModalInit(empty_menu);
        },
        edit(item){
            item.title = '编辑【'+item.name+'】'
            this.$refs.addeditmenu.onModalInit(item);
        },
        remove(item){
            console.log(item)
            this.$store.dispatch({
                type: "usercenter/deleteMenu",
                params: {id:item.id}
            }).then((res) => {
                
                if(res.status == '200'){
                    this.getAllMenu()
                }
            });
        },
        //递归树结构
        handleTreeData(treeItem){
            treeItem.title = treeItem.name;
            treeItem.key = treeItem.id;
            treeItem.children  = [];
            treeItem.scopedSlots= { title: 'custom' } ;
            treeItem.submenuList.sort(function(a,b){
                return parseInt(a.ordernum) > parseInt(b.ordernum) ? 1 : -1
            });
            for (let index = 0; index < treeItem.submenuList.length; index++) {
                const r_child = treeItem.submenuList[index];
                treeItem.children.push(this.handleTreeData(r_child)) 

            }
            return treeItem;
        },
        getAllMenu(){
            this.$store.dispatch({
                type: "rolecenter/getAllMenu",
                showMsg: false
            }).then((res)=>{
                let origin_data = res.data.data;
                //排序
                origin_data.sort(function(a,b){
                    return parseInt(a.ordernum) > parseInt(b.ordernum) ? 1 : -1
                });
                for (let index = 0; index < origin_data.length; index++) {
                    const element = origin_data[index];
                    element.title = element.name;
                    element.key = element.id;
                    element.scopedSlots= { title: 'custom' } ;
                    this.handleTreeData(element)
                }

                this.treeData = origin_data
            });
        }
    },
    computed:{
      
    },
    components:{
        menuItem
    },
    mounted(){
        this.getAllMenu()
    }
};
</script>
<style scoped>
.ant-card-body .but_type {
  float: right;
  position: absolute;
  right: 40px;
}

.underline{
  position: absolute;
  width: calc(100% - 75px);
  height: 5px;
  border-bottom:1px solid #f4e4e4;
}

</style>
